import Vue from "vue";
import Swiper, { Mousewheel, EffectCoverflow } from "swiper";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/swiper.min.css";

Swiper.use([Mousewheel, EffectCoverflow]);
Vue.use(VueAwesomeSwiper);
